// src/components/CreateBatch.js
import React, { useState, useEffect } from 'react';
import Papa from 'papaparse';
import {
  collection,
  addDoc,
  serverTimestamp,
  query,
  where,
  getDocs
} from 'firebase/firestore';
import { db } from '../firebase';

export default function CreateBatch({ onCreated }) {
  const [name, setName]           = useState('');
  const [subject, setSubject]     = useState('');
  const [teacherId, setTeacherId] = useState('');
  const [teachers, setTeachers]   = useState([]);
  const [csvFile, setCsvFile]     = useState(null);
  const [error, setError]         = useState('');

  useEffect(() => {
    (async () => {
      const q = query(collection(db, 'users'), where('role', '==', 'teacher'));
      const snap = await getDocs(q);
      setTeachers(snap.docs.map(d => ({ id: d.id, name: d.data().name })));
    })();
  }, []);

  const handleFileChange = e => setCsvFile(e.target.files[0]);

  const handleCreate = async () => {
    setError('');
    if (!teacherId) {
      setError('Please select a teacher.');
      return;
    }
    const batchRef = await addDoc(collection(db, 'batches'), {
      batch_name: name,
      subject,
      teacher_id: teacherId
    });
    const batchId = batchRef.id;

    if (csvFile) {
      const text = await csvFile.text();
      const { data, errors } = Papa.parse(text, {
        header: true,
        skipEmptyLines: true
      });
      if (errors.length) {
        setError('CSV parse error: ' + errors[0].message);
      } else {
        await Promise.all(data.map(async row => {
          const [dd, mm, yyyy] = row.date_of_joining.split('-').map(Number);
          const doj = new Date(yyyy, mm - 1, dd);
          await addDoc(collection(db, 'students'), {
            name:            row.name,
            email:           row.email,
            mobile:          row.mobile,
            class:           row.class,
            school:          row.school,
            father_name:     row.father_name,
            father_phone:    row.father_phone,
            mother_name:     row.mother_name,
            mother_phone:    row.mother_phone,
            date_of_joining: doj,
            total_fees:      Number(row.total_fees),
            batch_ids:       [batchId],
            created_at:      serverTimestamp()
          });
        }));
      }
    }

    // Only call onCreated if it's actually a function
    if (typeof onCreated === 'function') {
      onCreated();
    }
  };

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold">Create New Batch</h2>

      <input
        type="text"
        placeholder="Batch Name"
        value={name}
        onChange={e => setName(e.target.value)}
        className="border p-2 rounded w-full"
      />

      <input
        type="text"
        placeholder="Subject"
        value={subject}
        onChange={e => setSubject(e.target.value)}
        className="border p-2 rounded w-full"
      />

      <div>
        <label className="block mb-1 font-medium">Teacher</label>
        <select
          value={teacherId}
          onChange={e => setTeacherId(e.target.value)}
          className="border p-2 rounded w-full"
        >
          <option value="">Select a teacher…</option>
          {teachers.map(t => (
            <option key={t.id} value={t.id}>
              {t.name}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label className="block mb-1">Upload Students CSV</label>
        <input type="file" accept=".csv" onChange={handleFileChange} />
        <a href="/template.csv" download className="text-blue-600 underline ml-4">
          Download CSV template
        </a>
      </div>

      {error && <p className="text-red-600">{error}</p>}

      <button
        onClick={handleCreate}
        className="px-4 py-2 bg-green-600 text-white rounded"
      >
        Create Batch
      </button>
    </div>
  );
}
